import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
export function PurchaseSection() {
  return <section id="compra" className="py-8 md:py-16 px-3 bg-brand-dark scroll-mt-10 border-b border-white/10" data-id="element-226">
      <div className="max-w-4xl mx-auto" data-id="element-227">
        <div className="text-center mb-8" data-id="element-228">
          <div className="inline-block bg-brand-accent/10 text-brand-accent font-black px-6 py-2 rounded-full mb-4 border-2 border-brand-accent animate-pulse text-sm md:text-base tracking-widest uppercase shadow-[0_0_15px_rgba(234,179,8,0.3)]" data-id="element-229">
            ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </div>

          <div className="mb-4" data-id="element-230">
            <CountdownTimer data-id="element-231" />
          </div>

          <p className="text-sm md:text-lg font-black text-white mb-6 uppercase tracking-wide" data-id="element-232">
            Después sube el precio y no vuelve a bajar.
          </p>

          <div className="max-w-md mx-auto bg-brand-card p-4 rounded-xl border border-white/10 shadow-lg" data-id="element-233">
            <div className="flex justify-between text-xs md:text-sm font-black mb-2 uppercase" data-id="element-234">
              <span className="flex items-center text-red-500" data-id="element-235">
                <span className="w-2 h-2 rounded-full bg-red-500 mr-2 animate-ping" data-id="element-236"></span>
                🔴 Cupos al precio de lanzamiento
              </span>
              <span className="text-gray-400" data-id="element-237">Quedan pocos</span>
            </div>
            <div className="w-full bg-black rounded-full h-3 mb-2 overflow-hidden border border-white/5" data-id="element-238">
              <div className="bg-red-500 h-3 rounded-full w-[78%] relative overflow-hidden" data-id="element-239">
                <div className="absolute inset-0 bg-white/20 w-full animate-[shimmer_2s_infinite] -translate-x-full" data-id="element-240"></div>
              </div>
            </div>
            <p className="text-[10px] md:text-xs text-gray-400 text-right font-bold uppercase tracking-wider" data-id="element-241">
              78% de los cupos tomados
            </p>
          </div>
        </div>

        <h2 className="text-2xl md:text-4xl font-black text-center mb-8 text-white uppercase text-shadow-lg" data-id="element-242">
          💰 ELEGÍ TU KIT
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-243">
          {/* Basic Kit */}
          <div className="bg-brand-card rounded-2xl border-2 border-white/20 p-5 md:p-6 flex flex-col relative hover:border-brand-accent/50 transition-colors" data-id="element-244">
            <div className="mb-4" data-id="element-245">
              <h3 className="text-lg md:text-xl font-black text-white mb-2 flex items-start uppercase leading-tight" data-id="element-246">
                <span className="text-2xl mr-2" data-id="element-247">📘</span>
                <span data-id="element-248">KIT MANTENIMIENTO INDUSTRIAL LISTO</span>
              </h3>
              <p className="text-brand-accent font-black text-sm uppercase tracking-wide" data-id="element-249">
                6 Tomos + 4 Bonos
              </p>
            </div>

            <div className="bg-black p-3 rounded-lg mb-6 border border-white/10" data-id="element-250">
              <p className="text-xs md:text-sm text-gray-300 font-medium" data-id="element-251">
                <span className="font-black text-brand-accent uppercase" data-id="element-252">
                  Ideal para:
                </span>{' '}
                Docentes que quieren el año de mantenimiento resuelto
              </p>
            </div>

            <div className="mb-6 flex-grow flex flex-col items-center justify-center bg-white/5 rounded-xl py-4" data-id="element-253">
              <span className="text-base text-gray-500 line-through font-black mb-1" data-id="element-254">
                $45.000 ARS
              </span>
              <span className="text-4xl md:text-5xl font-black text-white" data-id="element-255">
                $19.990 <span className="text-xl text-gray-400" data-id="element-256">ARS</span>
              </span>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47960406851822:1" className="py-4 text-sm md:text-base" pulse={false} data-id="element-257">
              → QUIERO MI KIT AHORA
            </Button>
          </div>

          {/* Premium Kit */}
          <div className="bg-brand-card rounded-2xl border-4 border-brand-accent p-5 md:p-6 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_30px_rgba(234,179,8,0.2)]" data-id="element-258">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-brand-accent text-black font-black px-6 py-1.5 rounded-full text-xs md:text-sm tracking-widest shadow-lg whitespace-nowrap uppercase border-2 border-brand-dark" data-id="element-259">
              MÁS ELEGIDO ⭐
            </div>

            <div className="mb-4 mt-2" data-id="element-260">
              <h3 className="text-lg md:text-xl font-black text-white mb-2 flex items-start uppercase leading-tight" data-id="element-261">
                <span className="text-2xl mr-2" data-id="element-262">🏆</span>
                <span data-id="element-263">KIT COMPLETO + UPSELL PREMIUM ⭐</span>
              </h3>
              <p className="text-brand-accent font-black text-sm uppercase tracking-wide" data-id="element-264">
                6 Tomos + 4 Bonos + Upsell
              </p>
            </div>

            <div className="bg-brand-accent/10 p-3 rounded-lg mb-6 border border-brand-accent/30" data-id="element-265">
              <p className="text-xs md:text-sm text-gray-200 font-medium" data-id="element-266">
                <span className="font-black text-brand-accent uppercase" data-id="element-267">
                  Ideal para:
                </span>{' '}
                Docentes que quieren llevar a sus alumnos al siguiente nivel
                industrial real
              </p>
            </div>

            <div className="mb-6 flex-grow flex flex-col items-center justify-center bg-black rounded-xl py-4 border border-brand-accent/20" data-id="element-268">
              <span className="text-base text-gray-500 line-through font-black mb-1" data-id="element-269">
                $63.000 ARS
              </span>
              <span className="text-4xl md:text-5xl font-black text-brand-accent neon-glow" data-id="element-270">
                $27.990{' '}
                <span className="text-xl text-brand-accent/70" data-id="element-271">ARS</span>
              </span>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47960408817902:1" className="py-4 md:py-5 text-base md:text-lg shadow-[0_0_20px_rgba(234,179,8,0.4)]" pulse={true} data-id="element-272">
              → QUIERO EL KIT COMPLETO
            </Button>
          </div>
        </div>
      </div>
      <style data-id="element-273">{`
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
      `}</style>
    </section>;
}